import AppLayout from '@/app/layouts/AppLayout.vue';
import AuthLayout from '@/app/layouts/AuthLayout.vue';
import PublicLayout from '@/app/layouts/PublicLayout.vue';
import AppSidebarLayout from '@/app/layouts/AppSidebarLayout.vue';
import OverlayLayout from '@/app/layouts/OverlayLayout.vue';
import BlankLayout from '@/app/layouts/BlankLayout.vue';

export const layouts = {
    'app': AppLayout,
    'app-sidebar': AppSidebarLayout,
    'auth': AuthLayout,
    'public': PublicLayout,
    'overlay': OverlayLayout,
    'blank': BlankLayout,
};
